<template>
  <div>
    <div>
      <a-form layout="inline" class="searchForm search-form">
        <a-form-item label="课程名称">
          <a-input allowClear placeholder="请输入课程名称" v-model.trim="searchForm.courseName" />
        </a-form-item>
        <a-form-item label="学段">
          <a-select allowClear v-model="searchForm.period" placeholder="请选择" style="width: 180px">
            <a-select-option v-for="item in _data._period" :value="item">{{ item }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="getPageList(true)">查询</a-button>
        </a-form-item>
      </a-form>
    </div>
    <div>
      <a-table
        :rowSelection="rowSelection"
        :columns="columns"
        rowKey="id"
        :pagination="false"
        :loading="tableRelevant.tableLoading"
        :locale="tableRelevant.locale"
        :dataSource="tableRelevant.tableDataSource"
        :scroll="{ y: 400 }"
      >
      </a-table>
    </div>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import { CourseResource } from '@/utils/http'


const columns = [
  {
    title: '关联课程',
    dataIndex: 'name',
  },
  {
    title: '学段',
    dataIndex: 'period',
  },
  {
    title: '已有体验游戏数',
    dataIndex: 'experienceGameCount',
  },
]
export default {
  name: 'SelectExpCourse',
  props: {
    columns: {
      default: columns,
      type: Array,
    },
  },
  data() {
    return {
      visible: false,
      tableRelevant: tableRelevant.call(this),
      selectedRowKeys: [],
      selectedRows: [],
      searchForm: {
        courseName: undefined,
        period: undefined,
      },
    }
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onSelect: (record, selected) => {
          if (selected) {
            this.selectedRowKeys.push(record.id)
            this.selectedRows.push(record)
          } else {
            this.selectedRowKeys = this.selectedRowKeys.filter((key) => record.id != key)
            this.selectedRows = this.selectedRows.filter((item) => record.id != item.id)
          }
          this.$emit('changeCount', this.selectedRowKeys.length)
        },
        onSelectAll: (selected, selectedRows) => {
          if (selected) {
            this.selectedRowKeys = selectedRows.map((v) => v.id)
            this.selectedRows = selectedRows
          } else {
            this.selectedRowKeys = []
            this.selectedRows = []
          }
          this.$emit('changeCount', this.selectedRowKeys.length)
        },
      }
    },
  },
  methods: {
    getPageList(reset) {
      this.tableRelevant.tableLoading = true
      if (reset) {
        this.tableRelevant.tablePagination.current = 1
      }
      const seriesInfo = this.$store.getters['course/getSeriesInfo']()
      const params = {
        CourseSeriesId: seriesInfo.id,
        courseType: 2,
        courseName: this.searchForm.courseName === '' ? undefined : this.searchForm.courseName,
        period: this.searchForm.period === '' ? undefined : this.searchForm.period,
        isInclusionIntelligence:true
      }
      CourseResource.courseAll(params)
        .then((res) => {
          this.tableRelevant.tableDataSource = res.data
          this.tableRelevant.tableLoading = false
        })
        .catch((err) => {
          this.tableRelevant.tableLoading = false
        })
    },
  },
}
</script>
